"use strict";
/**
 * Enrichment type definitions shared across the application
 */
Object.defineProperty(exports, "__esModule", { value: true });
